// src/Utils/PublicRoute.js
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import RouteFallback from "../ui/RouteFallback";

const PublicRoute = () => {
  const { token, userRole, authChecked } = useAuth();

  // Avoid flashing the login/signup form to an already-authenticated user
  // before the session probe resolves.
  if (!authChecked) return <RouteFallback />;

  if (token) {
    if (userRole === "SuperAdmin") return <Navigate to="/admin" replace />;
    if (userRole === "Villager") return <Navigate to="/villager" replace />;
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
